import { BIRDS_GROUPS_CONSTS } from "@/features/events/birds-groups-events/types/birds-groups-events-consts.ts"

export const BIRD_GROUP_EVENT_LIST_VIEW = "/birds-groups-events"
export const NEW_BIRDS_GROUPS_EVENTS_VIEW = `${BIRD_GROUP_EVENT_LIST_VIEW}/new`
export const BIRDS_GROUPS_EVENT_VIEW = `${BIRD_GROUP_EVENT_LIST_VIEW}/:${BIRDS_GROUPS_CONSTS.BIRDS_GROUP_EVENT_ID}`
